import script from "./FormBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormBar.vue?vue&type=script&setup=true&lang=ts"

import "./FormBar.vue?vue&type=style&index=0&id=9fb58ade&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fb58ade"]])

export default __exports__